import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/contract-management',
  component: Layout,
  name: 'ContractManagementParent',
  meta: { title: 'contract_management', root: true, auth: AUTH_KEYS.CONTRACT_MANAGEMENT },
  children: [
    {
      path: '/contract-management',
      name: 'ContractManagement',
      component: () => import('@/views/Contract/ContractManagement.vue'),
      meta: { title: 'Contract Management', auth: AUTH_KEYS.CONTRACT_MANAGEMENT, isHide: true }
    },
    {
      path: '/contract-management/contract-creation/:id',
      name: 'ContractTransporter',
      component: () => import('@/views/ContractCreation/ContractCreation.vue'),
      meta: {
        title: 'contract_creation',
        auth: AUTH_KEYS.CONTRACT_CREATION,
        isHide: true
      }
    },
    {
      path: '/contract-create/:id?',
      name: 'ContractCreation',
      component: () => import('@/views/ContractCreation/Index.vue'),
      meta: {
        title: 'contract_creation',
        auth: AUTH_KEYS.CONTRACT_CREATION,
        isHide: true
      },
      props: (route : any) => ({ mode: 'create' }), // Check route name to determine mode
      // children: [
      //   {
      //     path: '/contract-confirm/:id',
      //     name: 'ContractConfirmation',
      //     component: () => import('@/views/ContractCreation/Index.vue'),
      //     meta: {
      //       title: 'contract_confirm',
      //       auth: AUTH_KEYS.CONTRACT_CONFIRMATION,
      //       isHide: true
      //     },
      //     props: (route:any) => ({ mode: route.name === 'ContractConfirmation' ? 'confirm' : 'create' }), // Check route name to determine mode
      //   }
      // ]
    },
    {
      path: '/contract-confirm/:id?',
      name: 'ContractConfirmation',
      component: () => import('@/views/ContractCreation/Index.vue'),
      meta: {
        title: 'contract_confirm',
        auth: AUTH_KEYS.CONTRACT_CREATION,
        isHide: true
      },
      props: (route : any) => ({ mode:'confirm'  }), // Check route name to determine mode
    }
  ]
};
